export default "__VITE_ASSET__CTQOdUI3__"